import { render } from "./xjedit.vue?vue&type=template&id=66c03b1a&scoped=true"
import script from "./xjedit.vue?vue&type=script&lang=js"
export * from "./xjedit.vue?vue&type=script&lang=js"

import "./xjedit.vue?vue&type=style&index=0&id=66c03b1a&lang=scss&scoped=true"
import "./xjedit.vue?vue&type=style&index=1&id=66c03b1a&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c03b1a"]])

export default __exports__